import { apiHolder as api } from 'api';
import DefaultMailMenuConfig from './DefaultMailMenuConfig';
import { MAIL_MENU_ITEM } from '../../../constant';
import { findAndMergeDefaultMenuConfig } from '../util';
const systemApi = api.api.getSystemApi();
const isCorpMail = systemApi.getIsCorpMailMode();
import { getMailFromMails } from '@web-mail/util';
const MailListMenuMultConfig = [
    {
        key: MAIL_MENU_ITEM.RED_FLAG,
        group: '1',
    },
    {
        key: MAIL_MENU_ITEM.READ,
        group: '1',
    },
    {
        key: MAIL_MENU_ITEM.TAG,
        group: '1',
    },
    {
        key: MAIL_MENU_ITEM.WMFOLLOW,
        group: '1',
    },
    {
        key: MAIL_MENU_ITEM.MOVE,
        group: '2',
    },
    {
        key: MAIL_MENU_ITEM.DELETE,
        group: '2',
    },
    {
        key: MAIL_MENU_ITEM.DIRECT_DELETE,
        group: '2',
    },
    {
        key: MAIL_MENU_ITEM.TOP,
        group: '2',
    },
    {
        key: MAIL_MENU_ITEM.FORWARD_BY_ATTACH,
        group: '2',
    },
    {
        key: MAIL_MENU_ITEM.EXPORT,
        group: '2',
        show: (mails, defaultShow) => {
            const mail = getMailFromMails(mails);
            const { isThread } = mail;
            if (isThread) {
                return false;
            }
            return !!defaultShow && defaultShow(mail);
        },
    },
];
export default findAndMergeDefaultMenuConfig(MailListMenuMultConfig, DefaultMailMenuConfig);
